import React from "react";
import HeaderUser from "../global/header/HeaderUser";
import Sidebar from "../global/header/Sidebar";
import { Outlet } from "react-router-dom";

function RootUser() {
  return (
    <>
      <HeaderUser />
      <Sidebar />
      <div className="p-4 sm:ml-64 bg-gray-100">
        <div className="p-4 border-2 border-gray-200 border-dashed rounded-lg mt-16 sm:mt-20">
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default RootUser;
